import { ReactElement } from 'react'
import { RedirectToClassic } from '../../../Common/RedirectToClassic'
import { FEATURE_FLAGS, useFeatureFlagValue } from '../../../FeatureFlags'
import { ContactGoalAdmin } from './ContactGoalAdmin'

export const ContactGoalAdminPage = (): ReactElement => {
  const value = useFeatureFlagValue(FEATURE_FLAGS.QM_CONTACT_GOAL_ADMIN)

  return (
    <div className="h-full">
      {
        value === true
          ? <ContactGoalAdmin />
          : <RedirectToClassic to={'/admin/contactQueueClassifier'} />
      }
    </div>
  )
}
